module.exports = __webpack_public_path__ + "static/media/Industry-Medium.8524d71e.woff";